/* ==========================================================================
   PURESTEEZ THEME JS
   Vanilla only. Everything re-initialises on shopify:section:load.
   ========================================================================== */
(function () {
  'use strict';

  var PS = window.PS = window.PS || {};

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt); }

  function paidCartSubtotal(cart) {
    var giftValue = (cart.items || []).reduce(function (sum, item) {
      return item.properties && item.properties._puresteez_gift === 'true' ? sum + Math.max(0, Number(item.final_line_price) || 0) : sum;
    }, 0);
    return Math.max(0, (Number(cart.total_price) || 0) - giftValue);
  }

  function rootUrl() {
    var routes = (window.PSConfig && window.PSConfig.routes) || {};
    return routes.root_url || routes.root || '/';
  }

  function route(path) {
    return rootUrl().replace(/\/$/, '') + '/' + String(path || '').replace(/^\//, '');
  }

  function announce(message) {
    var region = $('[data-ps-live-region]');
    if (!region) return;
    region.textContent = '';
    window.setTimeout(function () { region.textContent = message; }, 10);
  }

  function requestJSON(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().catch(function () {
        throw new Error('The response could not be read. Check your cart before trying again.');
      }).then(function (data) {
        if (!response.ok) {
          throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
        }
        return data;
      });
    });
  }

  function money(cents) {
    var fmt = (window.PSConfig && window.PSConfig.moneyFormat) || '€{{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  }
  PS.money = money;

  function presentmentMoney(cents, currency) {
    if (currency && window.Intl && Intl.NumberFormat) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: currency
        }).format(cents / 100);
      } catch (error) { /* fall back to the theme money format */ }
    }
    return money(cents);
  }

  function track(name, payload, options) {
    if (window.PSTAnalytics) window.PSTAnalytics.emit(name, payload || {}, options || {});
  }

  function productConfiguration(form) {
    var state = form && form._pstPreviewState;
    if (state && state.contract) return state.contract;
    var input = form ? $('[data-pst-property="configuration"]', form) : null;
    if (!input || !input.value) return {};
    try { return JSON.parse(input.value); } catch (error) { return {}; }
  }

  function productEventPayload(form) {
    var contract = productConfiguration(form);
    var variant = form ? $('[data-ps-variant-select]', form) : null;
    var preview = form ? $('[data-pst-dynamic-preview]', form) : null;
    return {
      design_id: contract.design_id || '',
      colour_id: contract.colour_id || '',
      kit_id: contract.kit_id || '',
      product_id: preview ? preview.dataset.pstProductId || form.dataset.psProductId || '' : (form ? form.dataset.psProductId || '' : ''),
      variant_id: variant ? variant.value || '' : '',
      product_name: form ? form.dataset.psProductName || '' : '',
      product_type: form ? form.dataset.psProductType || '' : '',
      price: form ? Number(form.dataset.psProductPrice || 0) / 100 : 0,
      currency: form ? form.dataset.psCurrency || '' : '',
      quantity: 1
    };
  }

  function currentConfiguration() {
    var input = $('[data-pst-property="configuration"]');
    if (!input || !input.value) return {};
    try { return JSON.parse(input.value); } catch (error) { return {}; }
  }

  function matchingProperties(element) {
    if (!element || !element.dataset.pstMatchColourId) return {};
    return {
      Colour: element.dataset.pstMatchColourName || element.dataset.pstMatchColourId,
      _colour_id: element.dataset.pstMatchColourId,
      _pst_parent_design_id: element.dataset.pstMatchDesignId || ''
    };
  }

  function updateMatchingConfiguration(root, contract) {
    root = root || document;
    contract = contract || currentConfiguration();
    if (!contract.colour_id) return;
    $$('[data-pst-match-url]', root).forEach(function (link) {
      var target = new URL(link.dataset.pstBaseUrl || link.getAttribute('href'), window.location.origin);
      target.searchParams.set('colour', String(contract.colour_id).toLowerCase());
      target.searchParams.delete('size');
      var current = new URL(window.location.href);
      ['ref', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (key) {
        if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
      });
      link.href = target.pathname + target.search + target.hash;
    });
    $$('[data-pst-match-quick-add], [data-pst-match-bundle-item]', root).forEach(function (control) {
      control.dataset.pstMatchColourId = contract.colour_id;
      control.dataset.pstMatchColourName = contract.colour_name || contract.colour_id;
      control.dataset.pstMatchDesignId = contract.design_id || '';
    });
  }

  function initMatchingConfiguration(root) {
    updateMatchingConfiguration(root || document);
    if (document._pstMatchingInit) return;
    document._pstMatchingInit = true;
    on(document, 'pst:preview:change', function (event) {
      updateMatchingConfiguration(document, event.detail && event.detail.configuration);
    });
  }

  function cartAttribution() {
    var params = new URL(window.location.href).searchParams;
    var storageKey = 'pst_attribution_v1';
    var clean = function (value) {
      value = String(value || '').trim();
      return /^[A-Za-z0-9._-]{1,80}$/.test(value) ? value : '';
    };
    if (!window.PSTAnalytics || !window.PSTAnalytics.analyticsAllowed()) {
      try { window.localStorage.removeItem(storageKey); } catch (error) { /* storage is optional */ }
      return {};
    }
    var current = {
      ref: clean(params.get('ref')),
      utm_source: clean(params.get('utm_source')),
      utm_medium: clean(params.get('utm_medium')),
      utm_campaign: clean(params.get('utm_campaign')),
      utm_content: clean(params.get('utm_content')),
      utm_term: clean(params.get('utm_term')),
      gclid: clean(params.get('gclid')),
      fbclid: clean(params.get('fbclid')),
      ttclid: clean(params.get('ttclid'))
    };
    var hasCurrent = Object.keys(current).some(function (key) { return current[key]; });
    var stored = { first: {}, last: {} };
    try {
      stored = JSON.parse(window.localStorage.getItem(storageKey) || '') || stored;
    } catch (error) { stored = { first: {}, last: {} }; }
    if (hasCurrent) {
      if (!stored.first || !Object.keys(stored.first).some(function (key) { return stored.first[key]; })) stored.first = current;
      stored.last = current;
      try { window.localStorage.setItem(storageKey, JSON.stringify(stored)); } catch (error) { /* storage is optional */ }
    }
    var attributes = {};
    ['first', 'last'].forEach(function (touch) {
      var values = stored[touch] || {};
      Object.keys(current).forEach(function (key) {
        if (values[key]) attributes['pst_' + touch + '_' + key] = clean(values[key]);
      });
    });
    return attributes;
  }

  function persistCartAttribution(fallbackResponse) {
    var attributes = cartAttribution();
    Object.keys(attributes).forEach(function (key) { if (!attributes[key]) delete attributes[key]; });
    if (!Object.keys(attributes).length) return Promise.resolve(fallbackResponse);
    return requestJSON(route('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: attributes,
        sections: ['cart-drawer'],
        sections_url: window.location.pathname
      })
    }).catch(function () { return fallbackResponse; });
  }

  function initAttribution() {
    // Capture approved campaign identifiers on the landing page before an
    // internal navigation can remove them. cartAttribution deliberately
    // fails closed until Shopify reports analytics consent.
    cartAttribution();
    if (document._pstAttributionInit) return;
    document._pstAttributionInit = true;
    on(document, 'visitorConsentCollected', cartAttribution);
    on(document, 'pst:privacy-ready', cartAttribution);
  }

  function setCookie(name, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + '=1;expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }
  function hasCookie(name) {
    return document.cookie.split(';').some(function (c) { return c.trim().indexOf(name + '=') === 0; });
  }

  function lockScroll(lock) {
    document.body.classList.toggle('ps-no-scroll', !!lock);
  }

  /* ---------- scrim ---------- */
  function scrim(open) {
    var s = $('[data-ps-scrim]');
    if (s) s.classList.toggle('is-open', !!open);
    lockScroll(open);
  }
  PS.scrim = scrim;

  function closeAllPanels() {
    var returnFocus;
    $$('.ps-drawer.is-open, .ps-cart-drawer.is-open, .ps-search-drawer.is-open').forEach(function (el) {
      if (!returnFocus && el._psReturnFocus && document.contains(el._psReturnFocus)) returnFocus = el._psReturnFocus;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('ps-cart-is-open');
    scrim(false);
    if (returnFocus) returnFocus.focus();
  }

  function focusableElements(container) {
    if (!container) return [];
    return $$('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', container)
      .filter(function (element) {
        return !element.hidden && element.getAttribute('aria-hidden') !== 'true' && element.offsetParent !== null;
      });
  }

  function trapOpenDialog(event) {
    if (event.key !== 'Tab') return;
    var panel = $('.ps-drawer.is-open[role="dialog"], .ps-cart-drawer.is-open[role="dialog"], .ps-search-drawer.is-open[role="dialog"], .ps-popup.is-open[role="dialog"]');
    if (!panel) return;
    var focusable = focusableElements(panel);
    if (!focusable.length) {
      event.preventDefault();
      panel.setAttribute('tabindex', '-1');
      panel.focus();
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /* ==========================================================
     PREDICTIVE SEARCH
     ========================================================== */
  function initPredictiveSearch(root) {
    var drawer = $('[data-ps-search-drawer]');
    if (!drawer) return;
    var input = $('[data-ps-predictive-input]', drawer);
    var results = $('[data-ps-predictive-results]', drawer);
    var defaultMarkup = results ? results.innerHTML : '';
    var timer;
    var requestController;
    var returnFocus;

    function closeSearch() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.removeAttribute('aria-busy');
      if (requestController) requestController.abort();
      scrim(false);
      if (returnFocus && document.contains(returnFocus)) returnFocus.focus();
    }

    function openSearch(trigger) {
      closeAllPanels();
      returnFocus = trigger || document.activeElement;
      drawer._psReturnFocus = returnFocus;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      scrim(true);
      window.setTimeout(function () { if (input) input.focus(); }, 80);
    }

    $$('[data-ps-search-open]', root).forEach(function (trigger) {
      if (trigger._psSearchOpenInit) return;
      trigger._psSearchOpenInit = true;
      on(trigger, 'click', function (event) {
        event.preventDefault();
        openSearch(trigger);
      });
    });

    $$('[data-ps-search-close]', drawer).forEach(function (button) {
      if (button._psSearchCloseInit) return;
      button._psSearchCloseInit = true;
      on(button, 'click', closeSearch);
    });

    if (!input || !results || input._psPredictiveInit) return;
    input._psPredictiveInit = true;
    var searchForm = input.closest('form');
    if (searchForm && !searchForm._psSearchTrackingInit) {
      searchForm._psSearchTrackingInit = true;
      on(searchForm, 'submit', function () {
        track('pst_search_submitted', { result_count: results.querySelectorAll('[data-ps-search-result]').length, placement: 'search_drawer' });
      });
    }
    on(results, 'click', function (event) {
      var result = event.target.closest('[data-ps-search-result]');
      if (!result) return;
      track('pst_search_result_selected', {
        product_id: result.dataset.psProductId || '',
        product_name: result.dataset.psProductName || '',
        product_type: result.dataset.psProductType || '',
        placement: 'predictive_search'
      });
    });
    on(input, 'input', function () {
      window.clearTimeout(timer);
      var query = input.value.trim();
      if (query.length < 2) {
        if (requestController) requestController.abort();
        results.innerHTML = defaultMarkup;
        drawer.removeAttribute('aria-busy');
        return;
      }
      timer = window.setTimeout(function () {
        if (requestController) requestController.abort();
        requestController = 'AbortController' in window ? new AbortController() : null;
        var suggestUrl = new URL(route('search/suggest'), window.location.origin);
        suggestUrl.searchParams.set('q', query);
        suggestUrl.searchParams.set('resources[type]', 'product,collection,page');
        suggestUrl.searchParams.set('resources[limit]', '8');
        suggestUrl.searchParams.set('resources[options][unavailable_products]', 'last');
        suggestUrl.searchParams.set('section_id', 'predictive-search');
        drawer.setAttribute('aria-busy', 'true');
        fetch(suggestUrl.toString(), requestController ? { signal: requestController.signal } : {})
          .then(function (response) {
            if (!response.ok) throw new Error('Search is temporarily unavailable.');
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var source = doc.querySelector('[data-ps-predictive-source]');
            if (!source) throw new Error('Search results could not be displayed.');
            results.innerHTML = source.parentElement ? source.parentElement.innerHTML : source.outerHTML;
            drawer.removeAttribute('aria-busy');
          })
          .catch(function (error) {
            if (error.name === 'AbortError') return;
            drawer.removeAttribute('aria-busy');
            announce(error.message);
          });
      }, 180);
    });
  }
  PS.closeAllPanels = closeAllPanels;

  /* ==========================================================
     ANNOUNCEMENT BAR
     ========================================================== */
  function initAnnounce(root) {
    $$('[data-ps-announce]', root).forEach(function (bar) {
      var items = $$('.ps-announce__item', bar);
      if (items.length < 2) return;
      var speed = parseInt(bar.dataset.psAnnounce, 10) || 5000;
      var i = 0;
      if (bar._psTimer) clearInterval(bar._psTimer);
      bar._psTimer = setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, speed);
    });
  }

  /* ==========================================================
     HEADER + MEGA MENU + DRAWER
     ========================================================== */
  function initHeader(root) {
    var header = $('[data-ps-header]', root) || $('[data-ps-header]');
    if (!header) return;

    if (header.dataset.sticky === 'true' && !header._psScroll) {
      header._psScroll = function () {
        header.classList.toggle('is-solid', window.scrollY > 24);
      };
      window.addEventListener('scroll', header._psScroll, { passive: true });
      header._psScroll();
    }

    // Mega menu (desktop hover + keyboard)
    $$('[data-ps-mega-parent]', header).forEach(function (parent) {
      var mega = $('[data-ps-mega]', parent);
      if (!mega) return;
      var closeTimer;

      function open() {
        clearTimeout(closeTimer);
        $$('[data-ps-mega-parent].is-open', header).forEach(function (p) {
          if (p !== parent) { p.classList.remove('is-open'); var m = $('[data-ps-mega]', p); if (m) m.classList.remove('is-open'); }
        });
        parent.classList.add('is-open');
        mega.classList.add('is-open');
        header.classList.add('is-open');
      }
      function close() {
        closeTimer = setTimeout(function () {
          parent.classList.remove('is-open');
          mega.classList.remove('is-open');
          if (!$('[data-ps-mega].is-open', header)) header.classList.remove('is-open');
        }, 140);
      }

      on(parent, 'mouseenter', open);
      on(parent, 'mouseleave', close);
      on(mega, 'mouseenter', function () { clearTimeout(closeTimer); });
      on(mega, 'mouseleave', close);
      on(parent, 'focusin', open);
      on(parent, 'keydown', function (e) { if (e.key === 'Escape') { close(); } });
    });

    // Mobile drawer
    var drawer = $('[data-ps-nav-drawer]');
    $$('[data-ps-nav-open]').forEach(function (btn) {
      on(btn, 'click', function () {
        if (!drawer) return;
        closeAllPanels();
        drawer._psReturnFocus = btn;
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        scrim(true);
        var closeButton = $('[data-ps-nav-close]', drawer);
        if (closeButton) closeButton.focus();
      });
    });
    $$('[data-ps-nav-close]').forEach(function (btn) {
      on(btn, 'click', function () {
        if (drawer) drawer.classList.remove('is-open');
        if (drawer) drawer.setAttribute('aria-hidden', 'true');
        scrim(false);
        if (drawer && drawer._psReturnFocus && document.contains(drawer._psReturnFocus)) drawer._psReturnFocus.focus();
      });
    });
    $$('[data-ps-drawer-toggle]', drawer).forEach(function (btn) {
      on(btn, 'click', function () {
        var item = btn.closest('.ps-drawer__item');
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', String(open));
      });
    });
  }

  /* ==========================================================
     BEFORE / AFTER SLIDER
     ========================================================== */
  function initBeforeAfter(root) {
    $$('[data-ps-ba]', root).forEach(function (frame) {
      if (frame._psInit) return;
      frame._psInit = true;

      var range = $('[data-ps-ba-range]', frame);
      if (!range) return;
      function set() {
        frame.style.setProperty('--ps-ba-pos', range.value + '%');
      }
      on(range, 'input', set);
      on(range, 'change', set);
      on(range, 'pointerdown', function () { frame.classList.add('is-dragging'); });
      on(range, 'pointerup', function () { frame.classList.remove('is-dragging'); });
      on(range, 'pointercancel', function () { frame.classList.remove('is-dragging'); });
      on(range, 'blur', function () { frame.classList.remove('is-dragging'); });
      set();
    });
  }

  /* ==========================================================
     CAROUSEL DOTS
     ========================================================== */
  function initCarousels(root) {
    $$('[data-ps-carousel]', root).forEach(function (car) {
      if (car.dataset.psCarouselReady) return;
      var track = $('[data-ps-track]', car);
      var dots  = $('[data-ps-dots]', car);
      if (!track || !dots) return;
      car.dataset.psCarouselReady = 'true';
      function stepWidth(kid) { return kid.offsetWidth + (parseFloat(window.getComputedStyle(track).columnGap) || 0); }

      function build() {
        dots.innerHTML = '';
        var kids = Array.prototype.slice.call(track.children);
        if (!kids.length) return;
        var perView = Math.max(1, Math.round(track.clientWidth / kids[0].offsetWidth));
        var pages = Math.ceil(kids.length / perView);
        if (pages < 2) { dots.style.display = 'none'; return; }
        dots.style.display = '';
        for (var i = 0; i < pages; i++) {
          (function (page) {
            var b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', 'Go to slide ' + (page + 1));
            if (page === 0) b.classList.add('is-active');
            b.addEventListener('click', function () {
              track.scrollTo({ left: page * perView * stepWidth(kids[0]), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
            });
            dots.appendChild(b);
          })(i);
        }
      }

      function sync() {
        var kids = Array.prototype.slice.call(track.children);
        if (!kids.length) return;
        var perView = Math.max(1, Math.round(track.clientWidth / kids[0].offsetWidth));
        var page = Math.round(track.scrollLeft / (perView * stepWidth(kids[0])));
        $$('button', dots).forEach(function (b, i) { b.classList.toggle('is-active', i === page); });
      }

      build();
      on(track, 'scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      on(window, 'resize', build);
    });
  }

  /* ==========================================================
     COUNTDOWN
     ========================================================== */
  function initCountdown(root) {
    $$('[data-ps-countdown]', root).forEach(function (el) {
      var target = new Date(el.dataset.psCountdown).getTime();
      if (isNaN(target)) return;
      var out = {
        d: $('[data-unit="days"]', el),
        h: $('[data-unit="hours"]', el),
        m: $('[data-unit="minutes"]', el),
        s: $('[data-unit="seconds"]', el)
      };
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          clearInterval(el._psTimer);
          var section = el.closest('.shopify-section');
          if (section && el.dataset.psHideExpired === 'true') section.style.display = 'none';
          return;
        }
        var d = Math.floor(diff / 864e5);
        var h = Math.floor(diff % 864e5 / 36e5);
        var m = Math.floor(diff % 36e5 / 6e4);
        var s = Math.floor(diff % 6e4 / 1e3);
        if (out.d) out.d.textContent = pad(d);
        if (out.h) out.h.textContent = pad(h);
        if (out.m) out.m.textContent = pad(m);
        if (out.s) out.s.textContent = pad(s);
      }
      tick();
      if (el._psTimer) clearInterval(el._psTimer);
      el._psTimer = setInterval(tick, 1000);
    });
  }

  /* ==========================================================
     HOTSPOTS
     ========================================================== */
  function initHotspots(root) {
    $$('[data-ps-hotspot]', root).forEach(function (spot) {
      var btn = $('.ps-hotspot__dot', spot);
      on(btn, 'click', function (e) {
        e.stopPropagation();
        var wasOpen = spot.classList.contains('is-open');
        $$('[data-ps-hotspot].is-open').forEach(function (s) { s.classList.remove('is-open'); });
        spot.classList.toggle('is-open', !wasOpen);
      });
      on(spot, 'mouseenter', function () { spot.classList.add('is-open'); });
      on(spot, 'mouseleave', function () { spot.classList.remove('is-open'); });
    });
    on(document, 'click', function () {
      $$('[data-ps-hotspot].is-open').forEach(function (s) { s.classList.remove('is-open'); });
    });
  }

  /* ==========================================================
     GALLERY FILTERS (Real Builds)
     ========================================================== */
  function initFilters(root) {
    $$('[data-ps-filters]', root).forEach(function (wrap) {
      var grid = $('[data-ps-filter-grid]', wrap.closest('.shopify-section') || document);
      if (!grid) return;
      var items = $$('[data-ps-tag]', grid);
      var available = items.reduce(function (values, item) {
        var value = item.dataset.psTag;
        if (value && values.indexOf(value) === -1) values.push(value);
        return values;
      }, []);
      $$('[data-ps-filter]', wrap).forEach(function (btn) {
        if (btn.dataset.psFilter !== 'all' && available.indexOf(btn.dataset.psFilter) === -1) btn.hidden = true;
        on(btn, 'click', function () {
          var val = btn.dataset.psFilter;
          $$('[data-ps-filter]', wrap).forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          items.forEach(function (item) {
            item.hidden = !(val === 'all' || item.dataset.psTag === val);
          });
        });
      });
      if (available.length < 2) wrap.hidden = true;
    });
  }

  /* ==========================================================
     ACCORDIONS
     ========================================================== */
  function initAccordions(root) {
    $$('[data-ps-accordion] .ps-accordion__btn', root).forEach(function (btn) {
      if (btn._psAccordionInit) return;
      btn._psAccordionInit = true;
      on(btn, 'click', function () {
        var item = btn.closest('.ps-accordion__item');
        var open = item.classList.contains('is-open');
        var group = btn.closest('[data-ps-accordion]');
        if (group.dataset.psAccordion === 'single') {
          $$('.ps-accordion__item', group).forEach(function (i) {
            i.classList.remove('is-open');
            var otherButton = $('.ps-accordion__btn', i);
            if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
          });
        }
        item.classList.toggle('is-open', !open);
        btn.setAttribute('aria-expanded', String(!open));
        if (!open) {
          track('pst_product_detail_opened', {
            placement: group.closest('.ps-product__info') ? 'product_page' : 'faq',
            interaction_id: (btn.textContent || '').trim().slice(0, 80)
          });
        }
      });
    });
  }

  /* ==========================================================
     POPUP + STICKY TAB
     ========================================================== */
  function initPopup(root) {
    var popup = $('[data-ps-popup]', root) || $('[data-ps-popup]');
    var tab   = $('[data-ps-tab]');
    if (!popup && !tab) return;
    if (popup && popup._psPopupInit) return;
    if (popup) popup._psPopupInit = true;

    var cookieName = popup ? (popup.dataset.psCookie || 'ps_popup') : 'ps_popup';
    var days       = popup ? parseInt(popup.dataset.psDays || '14', 10) : 14;
    var delay      = popup ? parseInt(popup.dataset.psDelay || '6', 10) * 1000 : 6000;

    function open(trigger)  {
      if (!popup) return;
      popup._psReturnFocus = trigger || document.activeElement;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      var closeButton = $('[data-ps-popup-close]', popup);
      if (closeButton) closeButton.focus();
    }
    function close() {
      if (!popup) return;
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      lockScroll(false);
      setCookie(cookieName, days);
      if (tab) tab.classList.add('is-visible');
      if (popup._psReturnFocus && document.contains(popup._psReturnFocus)) popup._psReturnFocus.focus();
    }

    if (popup && !hasCookie(cookieName) && !(window.Shopify && window.Shopify.designMode)) {
      setTimeout(open, delay);
    } else if (tab && !hasCookie('ps_tab_dismissed')) {
      setTimeout(function () { tab.classList.add('is-visible'); }, 2200);
    }

    $$('[data-ps-popup-close]', popup).forEach(function (b) { on(b, 'click', close); });
    on(popup, 'click', function (e) { if (e.target === popup) close(); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape' && popup && popup.classList.contains('is-open')) close(); });

    if (tab) {
      on($('[data-ps-tab-open]', tab), 'click', function (event) { open(event.currentTarget); });
      on($('[data-ps-tab-close]', tab), 'click', function (e) {
        e.stopPropagation();
        tab.classList.remove('is-visible');
        setCookie('ps_tab_dismissed', 30);
      });
    }
  }

  /* ==========================================================
     CART
     ========================================================== */
  function refreshCartCount(cart) {
    $$('[data-ps-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }

  function renderCartProgress(cart) {
    $$('[data-ps-cart-progress-base]').forEach(function (bar) {
      var baseThreshold = parseInt(bar.dataset.psCartProgressBase, 10);
      if (!baseThreshold) return;
      var cartCurrency = cart.currency || bar.dataset.psCartCurrency;
      var storeCurrency = bar.dataset.psStoreCurrency;
      var threshold = baseThreshold;
      if (cartCurrency && storeCurrency && cartCurrency !== storeCurrency) {
        var currency = window.Shopify && window.Shopify.currency;
        var rate = currency && currency.active === cartCurrency ? Number(currency.rate) : NaN;
        if (!Number.isFinite(rate) || rate <= 0) {
          var unavailable = $('[data-ps-gift-msg]', bar);
          if (unavailable) unavailable.textContent = bar.dataset.psProgressConversionUnavailable || '';
          bar.classList.remove('is-unlocked');
          return;
        }
        threshold = Math.round(baseThreshold * rate);
      }
      var total = cart.total_price;
      var pct = Math.min(100, (total / threshold) * 100);
      var fill = $('.ps-gift__fill', bar);
      var progress = $('.ps-gift__bar', bar);
      var msg  = $('[data-ps-gift-msg]', bar);
      if (fill) fill.style.width = pct + '%';
      if (progress) progress.setAttribute('aria-valuenow', String(Math.round(pct)));
      if (msg) {
        if (total >= threshold) {
          bar.classList.add('is-unlocked');
          msg.textContent = bar.dataset.psProgressUnlocked || '';
        } else {
          bar.classList.remove('is-unlocked');
          var away = presentmentMoney(threshold - total, cartCurrency);
          msg.textContent = (bar.dataset.psProgressPending || '').replace('{{amount}}', away);
        }
      }
    });
    $$('[data-ps-rewards]').forEach(function (rewards) {
      var shippingBase = parseInt(rewards.dataset.psShippingThreshold, 10) || 7400;
      var giftBase = parseInt(rewards.dataset.psGiftThreshold, 10) || 12000;
      var giftEnabled = rewards.dataset.psGiftEnabled === 'true';
      var currencyCode = cart.currency || rewards.dataset.psCartCurrency;
      var storeCurrency = rewards.dataset.psStoreCurrency;
      var rate = 1;
      if (currencyCode && storeCurrency && currencyCode !== storeCurrency) {
        var activeCurrency = window.Shopify && window.Shopify.currency;
        rate = activeCurrency && activeCurrency.active === currencyCode ? Number(activeCurrency.rate) : NaN;
      }
      if (!Number.isFinite(rate) || rate <= 0) return;
      var shippingThreshold = Math.round(shippingBase * rate);
      var giftThreshold = Math.round(giftBase * rate);
      var progressThreshold = giftEnabled ? giftThreshold : shippingThreshold;
      var paidSubtotal = paidCartSubtotal(cart);
      var giftConfigured = (cart.items || []).some(function (item) { return item.properties && item.properties._puresteez_gift === 'true'; });
      var message = $('[data-ps-rewards-message]', rewards);
      var fill = $('[data-ps-rewards-fill]', rewards);
      var progress = $('[role="progressbar"]', rewards);
      var action = $('[data-ps-gift-configure]', rewards);
      rewards.classList.toggle('has-shipping', paidSubtotal >= shippingThreshold);
      rewards.classList.toggle('has-gift', giftEnabled && paidSubtotal >= giftThreshold);
      if (fill) fill.style.width = Math.min(100, paidSubtotal / progressThreshold * 100) + '%';
      if (progress) progress.setAttribute('aria-valuenow', String(Math.round(Math.min(100, paidSubtotal / progressThreshold * 100))));
      if (paidSubtotal < shippingThreshold) {
        if (message) message.textContent = 'Add ' + presentmentMoney(shippingThreshold - paidSubtotal, currencyCode) + ' more for free standard shipping.';
      } else if (!giftEnabled) {
        if (message) message.textContent = 'You’ve unlocked free standard shipping.';
      } else if (paidSubtotal < giftThreshold) {
        if (message) message.textContent = 'Free shipping unlocked. Add ' + presentmentMoney(giftThreshold - paidSubtotal, currencyCode) + ' more to unlock a free personalized Rider ID Pack.';
      } else if (giftConfigured) {
        if (message) message.textContent = 'Full rewards unlocked: free shipping + free Rider ID.';
      } else if (message) {
        message.textContent = 'Free shipping and your free Rider ID are unlocked. Personalise your gift.';
      }
      if (action) action.hidden = !(giftEnabled && paidSubtotal >= giftThreshold && !giftConfigured && rewards.dataset.psGiftActionReady === 'true');
      if (paidSubtotal >= shippingThreshold) track('pst_free_shipping_unlocked', { current_subtotal: paidSubtotal, placement: 'cart' }, { onceKey: currencyCode + ':' + shippingThreshold });
      else track('pst_free_shipping_progress_seen', { current_subtotal: paidSubtotal, amount_to_threshold: shippingThreshold - paidSubtotal, placement: 'cart' }, { onceKey: currencyCode + ':' + paidSubtotal });
      if (giftEnabled && paidSubtotal >= giftThreshold) track('pst_gift_unlocked', { current_subtotal: paidSubtotal, placement: 'cart' }, { onceKey: currencyCode + ':' + giftThreshold });
      else if (giftEnabled && paidSubtotal >= shippingThreshold) track('pst_gift_progress_seen', { current_subtotal: paidSubtotal, amount_to_threshold: giftThreshold - paidSubtotal, placement: 'cart' }, { onceKey: currencyCode + ':' + paidSubtotal });
    });
  }

  function fetchCart() {
    return requestJSON(route('cart.js'))
      .then(function (cart) { refreshCartCount(cart); renderCartProgress(cart); return cart; });
  }
  PS.fetchCart = fetchCart;

  function initOfferInteractions(root) {
    $$('[data-ps-upsell]', root).forEach(function (upsell) {
      if (upsell._psOfferInit) return;
      upsell._psOfferInit = true;
      track('pst_upsell_impression', {
        product_id: upsell.dataset.psProductId || '',
        current_subtotal: parseInt(upsell.dataset.psCurrentSubtotal, 10) || 0,
        placement: 'cart_drawer',
        bundle_tier: upsell.dataset.psUpsellRole || ''
      }, { onceKey: (upsell.dataset.psProductId || '') + ':' + (upsell.dataset.psCurrentSubtotal || '') });
      var link = $('[data-ps-upsell-accept]', upsell);
      on(link, 'click', function () {
        track('pst_upsell_accepted', { product_id: upsell.dataset.psProductId || '', placement: 'cart_drawer', bundle_tier: upsell.dataset.psUpsellRole || '' });
      });
    });
    $$('[data-ps-gift-configure]', root).forEach(function (link) {
      if (link._psGiftInit) return;
      link._psGiftInit = true;
      on(link, 'click', function () { track('pst_gift_configuration_started', { placement: 'cart' }); });
    });
  }

  function replaceCartDrawer(sectionHtml) {
    if (!sectionHtml) return false;
    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var fresh = doc.querySelector('[data-ps-cart-inner]');
    var current = $('[data-ps-cart-inner]');
    if (!fresh || !current) return false;
    current.innerHTML = fresh.innerHTML;
    initCart(current);
    initOfferInteractions(current);
    return true;
  }

  function replaceMainCart(sectionHtml) {
    if (!sectionHtml) return false;
    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var fresh = doc.querySelector('[data-ps-main-cart]');
    var current = $('[data-ps-main-cart]');
    if (!fresh || !current) return false;
    current.replaceWith(fresh);
    initAll(fresh);
    return true;
  }

  function sectionFromResponse(data) {
    return data && data.sections && data.sections['cart-drawer'];
  }

  function openCartDrawer(sectionHtml, trigger) {
    var d = $('[data-ps-cart-drawer]');
    if (!d) return;
    if (trigger) d._psReturnFocus = trigger;
    var updated = replaceCartDrawer(sectionHtml);
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ps-cart-is-open');
    scrim(true);
    if (!updated) renderCartDrawer();
    var closeButton = $('[data-ps-cart-close]', d);
    if (closeButton) closeButton.focus();
  }
  PS.openCartDrawer = openCartDrawer;

  function renderCartDrawer() {
    var body = $('[data-ps-cart-body]');
    if (!body) return;
    fetch(route('?section_id=cart-drawer'))
      .then(function (r) {
        if (!r.ok) throw new Error('Unable to refresh the cart.');
        return r.text();
      })
      .then(function (html) {
        if (!replaceCartDrawer(html)) throw new Error('Unable to refresh the cart.');
        return fetchCart();
      })
      .catch(function (error) { announce(error.message); });
  }

  function addToCart(items) {
    return requestJSON(route('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: currentCartSections(),
        sections_url: window.location.pathname
      })
    }).then(function (data) {
      var mainSection = currentMainCartSection();
      if (mainSection && data.sections) replaceMainCart(data.sections[mainSection]);
      return data;
    });
  }
  PS.addToCart = addToCart;

  var cartPaletteCache = {};
  function initCartColourChips(root) {
    var chips = $$('[data-pst-cart-colour]', root);
    var urls = chips.reduce(function (list, chip) {
      var url = chip.dataset.pstPaletteUrl;
      if (url && list.indexOf(url) === -1) list.push(url);
      return list;
    }, []);
    urls.forEach(function (url) {
      if (!cartPaletteCache[url]) {
        cartPaletteCache[url] = requestJSON(url).then(function (registry) {
          return (registry.colors || []).reduce(function (map, colour) {
            map[colour.color_id] = colour.preview_hex;
            return map;
          }, {});
        });
      }
      cartPaletteCache[url].then(function (palette) {
        chips.forEach(function (chip) {
          if (chip.dataset.pstPaletteUrl !== url) return;
          var value = palette[chip.dataset.pstCartColour];
          if (value) chip.style.setProperty('--pst-cart-colour', value);
        });
      }).catch(function () { /* The colour name remains visible without the chip. */ });
    });
  }

  function updateCartLine(key, quantity, sectionIds) {
    return requestJSON(route('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: sectionIds,
        sections_url: window.location.pathname
      })
    });
  }

  function currentMainCartSection() {
    var main = $('[data-ps-main-cart]');
    return main ? main.dataset.psMainCartSection : '';
  }

  function currentCartSections() {
    return ['cart-drawer', currentMainCartSection()].filter(Boolean);
  }

  function applyCartResponse(cart, mainSectionId) {
    var drawerPresent = Boolean($('[data-ps-cart-inner]'));
    var drawerUpdated = replaceCartDrawer(sectionFromResponse(cart));
    var mainUpdated = !mainSectionId || replaceMainCart(cart.sections && cart.sections[mainSectionId]);
    refreshCartCount(cart);
    renderCartProgress(cart);
    if ((drawerPresent && !drawerUpdated) || !mainUpdated) {
      window.location.assign(route('cart'));
      return;
    }
    // Shopify can briefly return a stale total alongside an updated cart section.
    // Reconcile the progress indicator with a fresh cart read after the mutation.
    fetchCart().catch(function () { /* Keep the section-rendered cart when a refresh fails. */ });
  }

  function initCart(root) {
    initCartColourChips(root || document);
    $$('[data-ps-cart-open]').forEach(function (b) {
      if (b._psCartOpenInit) return;
      b._psCartOpenInit = true;
      on(b, 'click', function (e) { e.preventDefault(); openCartDrawer(null, b); });
    });
    $$('[data-ps-cart-close]').forEach(function (b) {
      if (b._psCartCloseInit) return;
      b._psCartCloseInit = true;
      on(b, 'click', function () {
        var d = $('[data-ps-cart-drawer]');
        if (d) d.classList.remove('is-open');
        if (d) d.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('ps-cart-is-open');
        scrim(false);
        if (d && d._psReturnFocus && document.contains(d._psReturnFocus)) d._psReturnFocus.focus();
      });
    });

    // quantity + remove inside drawer
    $$('[data-ps-cart-qty]', root).forEach(function (input) {
      if (input._psCartQtyInit) return;
      input._psCartQtyInit = true;
      var quantityTimer;

      function updateQuantity() {
        window.clearTimeout(quantityTimer);
        if (input.disabled) return;
        var quantity = Math.max(0, parseInt(input.value, 10) || 0);
        input.disabled = true;
        requestJSON(route('cart/change.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: input.dataset.psCartQty,
            quantity: quantity,
            sections: currentCartSections(),
            sections_url: window.location.pathname
          })
        }).then(function (cart) {
          applyCartResponse(cart, currentMainCartSection());
        })
          .catch(function (error) {
            input.value = input.defaultValue;
            input.disabled = false;
            announce(error.message);
          });
      }

      on(input, 'input', function () {
        window.clearTimeout(quantityTimer);
        quantityTimer = window.setTimeout(updateQuantity, 250);
      });
      on(input, 'change', updateQuantity);
      on(input, 'keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          updateQuantity();
        }
      });
    });
    $$('[data-ps-cart-remove]', root).forEach(function (btn) {
      if (btn._psCartRemoveInit) return;
      btn._psCartRemoveInit = true;
      on(btn, 'click', function () {
        btn.disabled = true;
        requestJSON(route('cart/change.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: btn.dataset.psCartRemove,
            quantity: 0,
            sections: currentCartSections(),
            sections_url: window.location.pathname
          })
        }).then(function (cart) {
          applyCartResponse(cart, currentMainCartSection());
        })
          .catch(function (error) { btn.disabled = false; announce(error.message); });
      });
    });

    $$('[data-ps-cart-page-qty]', root).forEach(function (input) {
      if (input._psCartPageQtyInit) return;
      input._psCartPageQtyInit = true;
      var quantityTimer;
      function updatePageQuantity() {
        window.clearTimeout(quantityTimer);
        if (input.disabled) return;
        var cartRoot = input.closest('[data-ps-main-cart]');
        var sectionId = cartRoot ? cartRoot.dataset.psMainCartSection : '';
        var quantity = Math.max(0, parseInt(input.value, 10) || 0);
        input.disabled = true;
        updateCartLine(input.dataset.psCartPageQty, quantity, ['cart-drawer', sectionId].filter(Boolean))
          .then(function (cart) { applyCartResponse(cart, sectionId); })
          .catch(function (error) {
            input.value = input.defaultValue;
            input.disabled = false;
            announce(error.message);
          });
      }
      on(input, 'input', function () {
        window.clearTimeout(quantityTimer);
        quantityTimer = window.setTimeout(updatePageQuantity, 180);
      });
      on(input, 'change', updatePageQuantity);
      on(input, 'keydown', function (event) {
        if (event.key === 'Enter') { event.preventDefault(); updatePageQuantity(); }
      });
    });

    $$('[data-ps-cart-page-remove]', root).forEach(function (button) {
      if (button._psCartPageRemoveInit) return;
      button._psCartPageRemoveInit = true;
      on(button, 'click', function () {
        var cartRoot = button.closest('[data-ps-main-cart]');
        var sectionId = cartRoot ? cartRoot.dataset.psMainCartSection : '';
        button.disabled = true;
        updateCartLine(button.dataset.psCartPageRemove, 0, ['cart-drawer', sectionId].filter(Boolean))
          .then(function (cart) {
            applyCartResponse(cart, sectionId);
          })
          .catch(function (error) { button.disabled = false; announce(error.message); });
      });
    });

    $$('[data-ps-checkout-form], [data-ps-checkout]', root).forEach(function (control) {
      if (control._psCheckoutTrackingInit) return;
      control._psCheckoutTrackingInit = true;
      on(control, control.tagName === 'FORM' ? 'submit' : 'click', function (event) {
        event.preventDefault();
        var trigger = control.tagName === 'FORM' ? $('[name="checkout"]', control) : control;
        if (trigger) trigger.disabled = true;
        requestJSON(route('cart.js')).then(function (cart) {
          var reward = $('[data-ps-rewards]');
          var thresholdBase = reward ? (parseInt(reward.dataset.psGiftThreshold, 10) || 12000) : 12000;
          var rate = 1;
          if (reward && cart.currency && reward.dataset.psStoreCurrency !== cart.currency) {
            var activeCurrency = window.Shopify && window.Shopify.currency;
            rate = activeCurrency && activeCurrency.active === cart.currency ? Number(activeCurrency.rate) : NaN;
          }
          var threshold = Number.isFinite(rate) && rate > 0 ? Math.round(thresholdBase * rate) : thresholdBase;
          var gifts = (cart.items || []).filter(function (item) { return item.properties && item.properties._puresteez_gift === 'true'; });
          var paidSubtotal = paidCartSubtotal(cart);
          var giftQuantity = gifts.reduce(function (sum, item) { return sum + (Number(item.quantity) || 0); }, 0);
          var giftCampaignReady = reward && reward.dataset.psGiftEnabled === 'true' && reward.dataset.psGiftActionReady === 'true';
          var giftCharged = gifts.some(function (item) { return Number(item.final_line_price) !== 0; });
          if (gifts.length && (!giftCampaignReady || giftQuantity !== 1 || giftCharged || !Number.isFinite(rate) || rate <= 0 || paidSubtotal < threshold)) {
            track('pst_checkout_blocked_invalid_gift', { current_subtotal: paidSubtotal, amount_to_threshold: Math.max(0, threshold - paidSubtotal), placement: 'cart' });
            return gifts.reduce(function (request, gift) {
              return request.then(function () {
                return updateCartLine(gift.key, 0, currentCartSections());
              });
            }, Promise.resolve()).then(function () {
              track('pst_gift_removed_below_threshold', { current_subtotal: paidSubtotal, placement: 'cart' });
              renderCartDrawer();
              throw new Error('Your free Rider ID was removed because this cart no longer qualifies. Review the cart before checkout.');
            });
          }
          window.location.assign(route('checkout'));
          return null;
        }).catch(function (error) {
          if (trigger) trigger.disabled = false;
          announce(error.message);
        });
      });
    });

    $$('[data-ps-qty-adjust]', root).forEach(function (button) {
      if (button._psQtyAdjustInit) return;
      button._psQtyAdjustInit = true;
      on(button, 'click', function () {
        var stepper = button.closest('.ps-qty-stepper');
        var input = stepper ? $('input[type="number"]', stepper) : null;
        if (!input || input.disabled) return;
        var step = parseInt(button.dataset.psQtyAdjust, 10) || 0;
        var minimum = parseInt(input.min, 10);
        if (isNaN(minimum)) minimum = 0;
        var maximum = parseInt(input.max, 10);
        var next = Math.max(minimum, (parseInt(input.value, 10) || 0) + step);
        if (!isNaN(maximum)) next = Math.min(maximum, next);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // Cross-sell quick add
    $$('[data-ps-quick-add]', root).forEach(function (btn) {
      if (btn._psQuickAddInit) return;
      btn._psQuickAddInit = true;
      on(btn, 'click', function (e) {
        e.preventDefault();
        var id = btn.dataset.psQuickAdd;
        var original = btn.textContent;
        btn.disabled = true;
        var item = { id: id, quantity: 1 };
        var properties = matchingProperties(btn);
        if (Object.keys(properties).length) item.properties = properties;
        addToCart([item]).then(function (data) {
          btn.classList.add('is-added');
          btn.textContent = 'Added';
          openCartDrawer(sectionFromResponse(data));
          fetchCart().catch(function (error) { announce(error.message); });
          if (btn.dataset.pstAttachmentEvent) track(btn.dataset.pstAttachmentEvent, {
            design_id: btn.dataset.pstMatchDesignId || '',
            colour_id: btn.dataset.pstMatchColourId || '',
            variant_id: id
          });
          setTimeout(function () {
            btn.classList.remove('is-added');
            btn.textContent = original;
            btn.disabled = false;
          }, 1800);
        }).catch(function (error) {
          btn.textContent = original;
          btn.disabled = false;
          announce(error.message);
        });
      });
    });
  }

  function propertiesFromFormData(formData) {
    var properties = {};
    formData.forEach(function (value, key) {
      var match = /^properties\[(.+)\]$/.exec(key);
      if (match && value !== '') properties[match[1]] = value;
    });
    return properties;
  }

  function sameProperties(first, second) {
    var left = first || {};
    var right = second || {};
    var leftKeys = Object.keys(left).sort();
    var rightKeys = Object.keys(right).sort();
    if (leftKeys.length !== rightKeys.length) return false;
    return leftKeys.every(function (key, index) {
      return key === rightKeys[index] && String(left[key]) === String(right[key]);
    });
  }

  function cartChangeWithProperties(key, quantity, properties) {
    return requestJSON(route('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        properties: properties,
        sections: ['cart-drawer'],
        sections_url: window.location.pathname
      })
    });
  }

  function replaceConfiguredLine(formData, editKey) {
    var variantId = String(formData.get('id') || '');
    var properties = propertiesFromFormData(formData);
    return requestJSON(route('cart.js')).then(function (cart) {
      var current = cart.items.find(function (item) { return item.key === editKey; });
      if (!current) throw new Error('This cart item changed in another tab. Open the cart and try again.');
      var preservedQuantity = current.quantity;

      if (String(current.variant_id) === variantId) {
        return cartChangeWithProperties(editKey, preservedQuantity, properties);
      }

      var matchingBefore = cart.items.find(function (item) {
        return item.key !== editKey && String(item.variant_id) === variantId && sameProperties(item.properties, properties);
      });
      var replacement = new FormData();
      replacement.append('id', variantId);
      replacement.append('quantity', String(preservedQuantity));
      Object.keys(properties).forEach(function (key) {
        replacement.append('properties[' + key + ']', properties[key]);
      });
      replacement.append('sections', 'cart-drawer');
      replacement.append('sections_url', window.location.pathname);

      return requestJSON(route('cart/add.js'), { method: 'POST', body: replacement }).then(function (added) {
        return updateCartLine(editKey, 0, ['cart-drawer']).catch(function (removeError) {
          if (!added.key) throw removeError;
          var rollbackQuantity = matchingBefore ? matchingBefore.quantity : 0;
          return updateCartLine(added.key, rollbackQuantity, ['cart-drawer'])
            .catch(function () { /* The authoritative cart will still surface both lines for manual recovery. */ })
            .then(function () { throw removeError; });
        });
      });
    });
  }

  /* ==========================================================
     PRODUCT FORM
     ========================================================== */
  function initProductForm(root) {
    $$('[data-ps-product-form]', root).forEach(function (form) {
      if (form._psInit) return;
      form._psInit = true;
      on(form, 'submit', function (e) {
        if (form.dataset.psPurchaseReady === 'false') {
          e.preventDefault();
          announce('This product is not available to order yet.');
          return;
        }
        var preview = form._pstPreviewState || $('[data-pst-dynamic-preview]', form);
        if (preview) {
          var previewValid = window.PSTDynamicPreview && window.PSTDynamicPreview.validateForm(form);
          if (!previewValid) {
            e.preventDefault();
            var previewError = $('[data-ps-form-error]', form);
            var previewMessage = 'Choose a valid design and print colour before adding this item.';
            if (previewError && previewError.hidden) {
              previewError.textContent = previewMessage;
              previewError.hidden = false;
            }
            announce(previewError && previewError.textContent ? previewError.textContent : previewMessage);
            return;
          }
        }
        var personalization = $('[data-ps-personalization-contract]', form);
        if (personalization && !window.PSPersonalization) {
          e.preventDefault();
          announce('Product options could not load. Please refresh before ordering.');
          return;
        }
        if (personalization && window.PSPersonalization) {
          var contractScript = $('[data-ps-personalization-contract-json]', personalization);
          var payloadInput = $('[data-ps-personalization-payload]', personalization);
          var personalizationErrors = $('[data-ps-personalization-errors]', personalization);
          var contract;
          try { contract = JSON.parse(contractScript.textContent); } catch (error) { contract = null; }
          var values = {};
          $$('[data-ps-personalization-input]', personalization).forEach(function (input) {
            values[input.dataset.psPersonalizationInput] = input.value;
          });
          var orderedVariant = variants.find(function (candidate) { return String(candidate.id) === String(variantInput.value); });
          var authoritativeChoices = window.PSPersonalization.variantValues(contract || { fields: [] }, orderedVariant);
          Object.keys(authoritativeChoices).forEach(function (key) { values[key] = authoritativeChoices[key]; });
          var validation = window.PSPersonalization.validate(contract, values);
          if (!validation.valid) {
            e.preventDefault();
            if (personalizationErrors) {
              personalizationErrors.textContent = validation.errors.join(' ');
              personalizationErrors.hidden = false;
            }
            announce(validation.errors.join(' '));
            return;
          }
          if (payloadInput) payloadInput.value = JSON.stringify(validation.payload);
          if (personalizationErrors) { personalizationErrors.textContent = ''; personalizationErrors.hidden = true; }
          var giftCampaign = new URL(window.location.href).searchParams.get('gift');
          if (giftCampaign === 'aov_120_rider_id' && personalization.dataset.psGiftEnforcementReady !== 'true') {
            e.preventDefault();
            var giftUnavailable = 'The free Rider ID is in preview and cannot be added until checkout enforcement is active.';
            if (personalizationErrors) { personalizationErrors.textContent = giftUnavailable; personalizationErrors.hidden = false; }
            announce(giftUnavailable);
            return;
          }
        }
        if (form.dataset.psAjax !== 'true') return;
        e.preventDefault();
        var btn = $('[data-ps-add-button]', form);
        var errorBox = $('[data-ps-form-error]', form);
        var editInput = $('[data-pst-edit-key]', form);
        var editKey = editInput ? editInput.value : '';
        var label = btn ? btn.textContent : '';
        if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
        if (btn) { btn.disabled = true; btn.textContent = editKey ? 'Updating…' : 'Adding…'; }
        var formData = new FormData(form);
        if (personalization && validation && validation.valid) {
          var lineProperties = window.PSPersonalization.lineProperties(contract, validation.payload);
          var activeGiftCampaign = new URL(window.location.href).searchParams.get('gift');
          if (activeGiftCampaign === 'aov_120_rider_id' && personalization.dataset.psGiftEnforcementReady === 'true') {
            lineProperties._puresteez_gift = 'true';
            lineProperties._puresteez_campaign = 'aov_120_rider_id';
            lineProperties._puresteez_threshold = '12000';
          }
          Object.keys(lineProperties).forEach(function (key) { formData.set('properties[' + key + ']', lineProperties[key]); });
        }
        formData.append('sections', 'cart-drawer');
        formData.append('sections_url', window.location.pathname);
        track('pst_add_to_cart_attempted', productEventPayload(form));
        var operation = editKey ? replaceConfiguredLine(formData, editKey) : requestJSON(route('cart/add.js'), {
          method: 'POST',
          body: formData
        });
        operation.then(persistCartAttribution).then(function (data) {
            if (btn) { btn.textContent = label; btn.disabled = false; }
            openCartDrawer(sectionFromResponse(data));
            fetchCart().catch(function (error) { announce(error.message); });
            track('pst_add_to_cart_succeeded', productEventPayload(form));
            if (editKey) {
              track('pst_configuration_edited', productEventPayload(form));
              var cleanUrl = new URL(window.location.href);
              cleanUrl.searchParams.delete('edit');
              window.history.replaceState({}, '', cleanUrl.toString());
              if (editInput) editInput.value = '';
              if (form._pstPreviewState) form._pstPreviewState.editKey = '';
              var quantityField = $('[data-ps-product-quantity]', form);
              if (quantityField) quantityField.hidden = false;
              updateVariant();
            }
          })
          .catch(function (error) {
            if (btn) { btn.textContent = label; btn.disabled = false; }
            if (errorBox) { errorBox.textContent = error.message; errorBox.hidden = false; }
            track('pst_add_to_cart_failed', Object.assign(productEventPayload(form), { error_code: editKey ? 'EDIT_FAILED' : 'ADD_FAILED' }));
            announce(error.message);
          });
      });

      // Resolve complete option combinations to one authoritative Shopify variant.
      var variantData = $('[data-ps-variant-data]', form);
      var variantInput = $('[data-ps-variant-select]', form);
      var variants = [];
      if (variantData) {
        try { variants = JSON.parse(variantData.textContent); } catch (error) { variants = []; }
      }

      function selectedOptions() {
        return $$('[data-ps-option]', form).map(function (group) {
          var active = $('[data-ps-option-value].is-active', group);
          return active ? active.dataset.psOptionValue : '';
        });
      }

      function updateVariant() {
        var options = selectedOptions();
        var variant;
        if (!options.length) {
          variant = variants.find(function (candidate) {
            return variantInput && String(candidate.id) === String(variantInput.value);
          }) || variants[0];
        } else {
          variant = variants.find(function (candidate) {
            return candidate.options.every(function (value, index) { return value === options[index]; });
          });
        }
        var addButton = $('[data-ps-add-button]', form);
        var price = $('[data-ps-price]', form.closest('.ps-product') || document);
        var errorBox = $('[data-ps-form-error]', form);
        var sticky = $('[data-ps-sticky-product="' + form.dataset.psSectionId + '"]');
        var stickyPrice = sticky ? $('[data-ps-sticky-price]', sticky) : null;
        var stickyButton = sticky ? $('[data-ps-sticky-add]', sticky) : null;
        var savings = $('[data-ps-savings]', form.closest('.ps-product') || document);
        var availability = $('[data-ps-availability]', form.closest('.ps-product') || document);

        if (variantInput) variantInput.value = variant ? variant.id : '';
        var boundContract = $('[data-ps-personalization-contract-json]', form);
        if (boundContract && window.PSPersonalization) {
          try {
            var boundValues = window.PSPersonalization.variantValues(JSON.parse(boundContract.textContent), variant);
            $$('[data-ps-variant-bound]', form).forEach(function (input) {
              input.value = boundValues[input.dataset.psPersonalizationInput] || '';
              input.dispatchEvent(new Event('change', { bubbles: true }));
            });
          } catch (error) { /* Validation blocks submission if contract data is invalid. */ }
        }
        if (addButton) {
          addButton.disabled = !variant || !variant.available;
          var currentAddLabel = variant && ['Frame Design', 'Helmet Name'].indexOf(form.dataset.psProductType) !== -1
            ? addButton.dataset.addLabelBase + ' — ' + presentmentMoney(variant.price, form.dataset.psCurrency)
            : addButton.dataset.addLabel;
          var editingLine = $('[data-pst-edit-key]', form);
          if (editingLine && editingLine.value) currentAddLabel = addButton.dataset.updateLabel;
          addButton.textContent = !variant ? addButton.dataset.unavailableLabel : (variant.available ? currentAddLabel : addButton.dataset.soldOutLabel);
        }
        if (variant) form.dataset.psProductPrice = variant.price;
        if (price && variant) {
          price.innerHTML = (variant.compare_at_price && variant.compare_at_price > variant.price ? '<s>' + money(variant.compare_at_price) + '</s> ' : '') + money(variant.price);
        }
        if (stickyPrice && variant) stickyPrice.textContent = money(variant.price);
        if (stickyButton) {
          stickyButton.disabled = !variant || !variant.available;
          stickyButton.textContent = !variant ? stickyButton.dataset.unavailableLabel : (variant.available ? stickyButton.dataset.addLabel : stickyButton.dataset.soldOutLabel);
        }
        if (savings) {
          var hasSaving = variant && variant.compare_at_price && variant.compare_at_price > variant.price;
          savings.hidden = !hasSaving;
          if (hasSaving) savings.textContent = 'Save ' + Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100) + '%';
        }
        if (availability && variant) {
          availability.classList.toggle('is-available', variant.available);
          var availabilityText = $('b', availability);
          var preorder = availability.dataset.psPreorder === 'true';
          if (availabilityText) availabilityText.textContent = variant.available ? (preorder ? 'Pre-order' : 'Available') : 'Sold out';
        }
        if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }

        $$('[data-ps-option]', form).forEach(function (group, groupIndex) {
          $$('[data-ps-option-value]', group).forEach(function (button) {
            var possible = variants.some(function (candidate) {
              return candidate.available && candidate.options[groupIndex] === button.dataset.psOptionValue;
            });
            button.disabled = !possible;
          });
        });

        if (variant && variant.featured_media) selectGalleryMedia(form.closest('.ps-product'), String(variant.featured_media.id));
        var hasDynamicPreview = Boolean($('[data-pst-dynamic-preview]', form) && window.PSTDynamicPreview);
        if (variant && window.history && window.history.replaceState && !hasDynamicPreview) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
        form.dispatchEvent(new CustomEvent('pst:variant:change', {
          bubbles: true,
          detail: { variantId: variant ? String(variant.id) : '', options: options.slice() }
        }));
        if (window.PSTDynamicPreview) {
          window.PSTDynamicPreview.syncProductForm(form, Boolean(variant && variant.available));
        } else if ($('[data-pst-dynamic-preview]', form)) {
          if (addButton) addButton.disabled = true;
          if (stickyButton) stickyButton.disabled = true;
        }
        if (form.dataset.psPurchaseReady === 'false' || ($('[data-ps-personalization-contract]', form) && !window.PSPersonalization)) {
          if (addButton) { addButton.disabled = true; addButton.textContent = addButton.dataset.unavailableLabel; }
          if (stickyButton) { stickyButton.disabled = true; stickyButton.textContent = stickyButton.dataset.unavailableLabel; }
        }
      }

      $$('[data-ps-option-value]', form).forEach(function (button) {
        on(button, 'click', function () {
          var group = button.closest('[data-ps-option]');
          $$('[data-ps-option-value]', group).forEach(function (other) {
            other.classList.toggle('is-active', other === button);
            other.setAttribute('aria-pressed', String(other === button));
          });
          updateVariant();
        });
      });
      if (variants.length) updateVariant();

      var personalization = $('[data-ps-personalization-contract]', form);
      if (personalization) {
        var preview = $('[data-ps-personalization-preview]', personalization);
        var svgNS = 'http://www.w3.org/2000/svg';
        var flagColours = {
          FR: { direction: 'vertical', colours: ['#0055A4', '#FFFFFF', '#EF4135'] },
          BE: { direction: 'vertical', colours: ['#111111', '#FFD90C', '#EF3340'] },
          EE: { direction: 'horizontal', colours: ['#4891D9', '#111111', '#FFFFFF'] },
          LV: { direction: 'horizontal', colours: ['#9E3039', '#FFFFFF', '#9E3039'], ratios: [2, 1, 2] }
        };
        var countryCodes = {
          AUSTRIA: 'AT', BELGIUM: 'BE', BULGARIA: 'BG', CANADA: 'CA', CROATIA: 'HR', CYPRUS: 'CY', CZECHIA: 'CZ', DENMARK: 'DK',
          ESTONIA: 'EE', FINLAND: 'FI', FRANCE: 'FR', GERMANY: 'DE', GREECE: 'GR', HUNGARY: 'HU', IRELAND: 'IE', ITALY: 'IT',
          LATVIA: 'LV', LITHUANIA: 'LT', LUXEMBOURG: 'LU', MALTA: 'MT', NETHERLANDS: 'NL', NORWAY: 'NO', POLAND: 'PL', PORTUGAL: 'PT',
          ROMANIA: 'RO', SLOVAKIA: 'SK', SLOVENIA: 'SI', SPAIN: 'ES', SWEDEN: 'SE', SWITZERLAND: 'CH', UNITED_KINGDOM: 'GB', UNITED_STATES: 'US'
        };
        var previewColours = { WHITE: '#F4F2EC', BLACK: '#111111', TURQUOISE: '#20B8C5', BLUE: '#155AD6', RED: '#E63B35', GOLD: '#B89535' };

        function personalizationValues() {
          var values = {};
          $$('[data-ps-personalization-input]', personalization).forEach(function (input) { values[input.dataset.psPersonalizationInput] = input.value; });
          return values;
        }

        function drawFlag(group, flag, clipped, clipId) {
          group.replaceChildren();
          if (!flag) { group.hidden = true; return; }
          group.hidden = false;
          var x = clipped ? 80 : 68;
          var y = clipped ? 110 : 119;
          var width = clipped ? 560 : 72;
          var height = clipped ? 58 : 30;
          var ratios = flag.ratios || [1, 1, 1];
          var ratioTotal = ratios.reduce(function (sum, ratio) { return sum + ratio; }, 0);
          var cursor = flag.direction === 'vertical' ? x : y;
          flag.colours.forEach(function (colour, index) {
            var rect = document.createElementNS(svgNS, 'rect');
            var portion = (flag.direction === 'vertical' ? width : height) * ratios[index] / ratioTotal;
            rect.setAttribute('x', flag.direction === 'vertical' ? cursor : x);
            rect.setAttribute('y', flag.direction === 'horizontal' ? cursor : y);
            rect.setAttribute('width', flag.direction === 'vertical' ? portion : width);
            rect.setAttribute('height', flag.direction === 'horizontal' ? portion : height);
            rect.setAttribute('fill', colour);
            if (clipped) rect.setAttribute('clip-path', 'url(#' + clipId + ')');
            group.appendChild(rect);
            cursor += portion;
          });
          if (!clipped) {
            var border = document.createElementNS(svgNS, 'rect');
            border.setAttribute('x', x); border.setAttribute('y', y); border.setAttribute('width', width); border.setAttribute('height', height);
            border.setAttribute('fill', 'none'); border.setAttribute('stroke', '#111'); border.setAttribute('stroke-width', '2');
            group.appendChild(border);
          }
        }

        function updatePersonalizationPreview() {
          $$('[data-ps-character-counter]', personalization).forEach(function (counter) {
            var input = counter.parentElement && $('[data-ps-personalization-input]', counter.parentElement);
            if (input) counter.textContent = Array.from(input.value || '').length + ' / ' + input.maxLength;
          });
          if (!preview) return;
          var values = personalizationValues();
          var single = values.name || values.your_name || '';
          var first = values.first_name || '';
          var surname = values.last_name || '';
          var stacked = /STACKED/.test(values.style || '');
          var mainText = stacked ? surname : (single || [first, surname].filter(Boolean).join(' '));
          var firstText = stacked ? first : '';
          var displayMain = (mainText || 'YOUR NAME').toLocaleUpperCase();
          var displayFirst = firstText.toLocaleUpperCase();
          var nameNode = $('[data-ps-preview-name]', preview);
          var firstNode = $('[data-ps-preview-first]', preview);
          var clipNode = $('[data-ps-preview-clip-text]', preview);
          var baseNode = $('[data-ps-preview-base]', preview);
          var flagGroup = $('[data-ps-preview-flag]', preview);
          var svg = $('[data-ps-preview-svg]', preview);
          var base = (values.base || 'TRANSPARENT').toUpperCase();
          var colourId = (values.letter_colour || values.letter_treatment || 'WHITE').toUpperCase();
          var fill = previewColours[colourId] || (base === 'WHITE' ? '#111111' : '#F4F2EC');
          var country = (values.country || '').toUpperCase();
          var iso = countryCodes[country] || (/^[A-Z]{2}$/.test(country) ? country : '');
          var mode = (values.nationality_mode || values.flag_treatment || values.letter_treatment || '').toUpperCase();
          var isFlagFill = mode.indexOf('FLAG_FILL') !== -1 && Boolean(flagColours[iso]);
          var isFlagChip = mode.indexOf('FLAG_CHIP') !== -1;
          if (nameNode) { nameNode.textContent = displayMain; nameNode.style.fill = isFlagFill ? 'transparent' : fill; }
          if (firstNode) { firstNode.textContent = displayFirst; firstNode.style.fill = fill; }
          if (clipNode) clipNode.textContent = displayMain;
          if (baseNode) {
            baseNode.style.fill = base === 'BLACK' ? '#111111' : (base === 'WHITE' ? '#F4F2EC' : 'transparent');
            baseNode.style.stroke = base === 'TRANSPARENT' ? 'rgba(255,255,255,.55)' : 'rgba(255,255,255,.12)';
          }
          if (svg) svg.classList.toggle('is-transparent', base === 'TRANSPARENT');
          var clipId = clipNode && clipNode.parentNode ? clipNode.parentNode.id : '';
          drawFlag(flagGroup, flagColours[iso], isFlagFill, clipId);
          if (!isFlagFill && !isFlagChip && flagGroup) flagGroup.hidden = true;
          if (flagGroup && isFlagChip) drawFlag(flagGroup, flagColours[iso], false, clipId);
          $$('[data-ps-character-counter]', personalization).forEach(function (counter) {
            var input = counter.parentElement && $('[data-ps-personalization-input]', counter.parentElement);
            if (input) counter.textContent = Array.from(input.value || '').length + ' / ' + input.maxLength;
          });
          var title = $('title', preview);
          if (title) title.textContent = 'Preview: ' + [displayFirst, displayMain].filter(Boolean).join(' ');
        }

        $$('[data-ps-preview-background]', personalization).forEach(function (button) {
          on(button, 'click', function () {
            var surface = button.dataset.psPreviewBackground;
            preview.dataset.psPreviewSurface = surface;
            $$('[data-ps-preview-background]', personalization).forEach(function (other) {
              var active = other === button;
              other.classList.toggle('is-active', active);
              other.setAttribute('aria-pressed', String(active));
            });
          });
        });

        function updatePersonalizationVisibility() {
          var values = personalizationValues();
          $$('[data-ps-personalization-field]', personalization).forEach(function (field) {
            if (!field.dataset.psVisibleField) return;
            var allowed = (field.dataset.psVisibleValues || '').split('|');
            var visible = allowed.indexOf(values[field.dataset.psVisibleField] || '') !== -1;
            field.hidden = !visible;
            var input = $('[data-ps-personalization-input]', field);
            if (input && !visible) input.value = '';
          });
          var summary = $('[data-ps-personalization-summary]', personalization);
          if (summary) {
            summary.replaceChildren();
            $$('[data-ps-personalization-field]', personalization).forEach(function (field) {
              var input = $('[data-ps-personalization-input]', field);
              if (field.hidden || !input || !input.value || input.hasAttribute('data-ps-variant-bound')) return;
              var row = document.createElement('div');
              row.className = 'ps-product-fact';
              var term = document.createElement('dt');
              term.textContent = $('label', field).textContent;
              var detail = document.createElement('dd');
              detail.textContent = input.tagName === 'SELECT' ? input.options[input.selectedIndex].textContent : input.value;
              row.append(term, detail);
              summary.append(row);
            });
          }
          updatePersonalizationPreview();
        }
        $$('[data-ps-personalization-input]', personalization).forEach(function (input) {
          on(input, 'change', updatePersonalizationVisibility);
          on(input, 'input', updatePersonalizationVisibility);
        });
        updatePersonalizationVisibility();

        var editKey = new URL(window.location.href).searchParams.get('edit');
        if (editKey) {
          requestJSON(route('cart.js')).then(function (cart) {
            var editing = cart.items.find(function (item) { return item.key === editKey; });
            if (!editing) throw new Error('This configured item is no longer in your cart.');
            var payload = {};
            try { payload = JSON.parse(editing.properties._puresteez_configuration_json || editing.properties._ps_payload || '{}'); } catch (error) { payload = {}; }
            $$('[data-ps-personalization-input]', personalization).forEach(function (input) {
              var key = input.dataset.psPersonalizationInput;
              if (Object.prototype.hasOwnProperty.call(payload, key) && !input.hasAttribute('data-ps-variant-bound')) input.value = payload[key] || '';
            });
            updatePersonalizationVisibility();
            var editInput = $('[data-pst-edit-key]', form);
            if (!editInput) {
              editInput = document.createElement('input');
              editInput.type = 'hidden';
              editInput.setAttribute('data-pst-edit-key', '');
              form.appendChild(editInput);
            }
            editInput.value = editing.key;
            var editButton = $('[data-ps-add-button]', form);
            if (editButton && editButton.dataset.updateLabel) editButton.textContent = editButton.dataset.updateLabel;
            var editQuantity = $('[data-ps-product-quantity]', form);
            if (editQuantity) editQuantity.hidden = true;
            announce('Your saved personalisation is ready to edit.');
          }).catch(function (error) { announce(error.message); });
        }
      }

      var sticky = $('[data-ps-sticky-product="' + form.dataset.psSectionId + '"]');
      var mainButton = $('[data-ps-add-button]', form);
      var stickyButton = sticky ? $('[data-ps-sticky-add]', sticky) : null;
      if (stickyButton) on(stickyButton, 'click', function () { form.requestSubmit(); });
      if (sticky && mainButton) {
        function updateSticky() {
          var buttonBounds = mainButton.getBoundingClientRect();
          var buttonOutsideView = buttonBounds.bottom < 0 || buttonBounds.top > window.innerHeight - 120;
          sticky.classList.toggle('is-visible', window.scrollY > 180 && buttonOutsideView);
        }
        on(window, 'scroll', updateSticky, { passive: true });
        on(window, 'resize', updateSticky);
        updateSticky();
      }
    });

    function selectGalleryMedia(scope, mediaId) {
      if (!scope || !mediaId) return;
      $$('[data-ps-gallery-media]', scope).forEach(function (media) {
        media.classList.toggle('is-hidden', media.dataset.psGalleryMedia !== mediaId);
        if (media.dataset.psGalleryMedia !== mediaId) {
          $$('video', media).forEach(function (video) { video.pause(); });
        }
      });
      $$('[data-ps-gallery-thumb]', scope).forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.dataset.psGalleryThumb === mediaId);
        thumb.setAttribute('aria-pressed', String(thumb.dataset.psGalleryThumb === mediaId));
      });
    }

    // Gallery thumbs
    $$('[data-ps-gallery]', root).forEach(function (gal) {
      var productSection = gal.closest('[data-ps-product-section]') || gal;
      $$('[data-ps-gallery-thumb]', productSection).forEach(function (thumb) {
        if (thumb._psGalleryInit) return;
        thumb._psGalleryInit = true;
        thumb.setAttribute('aria-pressed', String(thumb.classList.contains('is-active')));
        on(thumb, 'click', function () {
          selectGalleryMedia(productSection, thumb.dataset.psGalleryThumb);
          track('pst_product_media_viewed', {
            product_id: productSection ? productSection.dataset.psProductId || '' : '',
            interaction_id: thumb.dataset.psGalleryThumb || '',
            placement: 'product_gallery'
          });
        });
      });
    });
  }

  function initConversionTracking(root) {
    $$('[data-pst-help-link]', root).forEach(function (link) {
      if (link._pstHelpTrackingInit) return;
      link._pstHelpTrackingInit = true;
      on(link, 'click', function () {
        track('pst_product_help_clicked', {
          placement: link.dataset.pstHelpPlacement || 'product_page',
          interaction_id: link.dataset.pstHelpLink || 'help'
        });
      });
    });
  }

  function initBundleBuilders(root) {
    $$('[data-ps-bundle]', root).forEach(function (bundle) {
      if (bundle._psInit) return;
      bundle._psInit = true;
      var items = $$('[data-ps-bundle-item]', bundle);
      var total = $('[data-ps-bundle-total]', bundle);
      var summary = $('[data-ps-bundle-summary]', bundle);
      var button = $('[data-ps-bundle-add]', bundle);
      var errorBox = $('[data-ps-bundle-error]', bundle);
      var tierButtons = $$('[data-ps-bundle-tier]', bundle);
      var tierPanels = $$('[data-ps-bundle-panel]', bundle);
      track('pst_bundle_opened', { bundle_type: bundle.dataset.psBundleType || 'configuration_aware' });
      track('pst_bundle_viewed', { placement: 'bundle_builder', bundle_tier: 'offer_ladder' }, { onceKey: window.location.pathname });

      function selectTier(id) {
        tierButtons.forEach(function (tierButton) {
          var active = tierButton.dataset.psBundleTier === id;
          tierButton.classList.toggle('is-active', active);
          tierButton.setAttribute('aria-selected', String(active));
        });
        tierPanels.forEach(function (panel) { panel.hidden = panel.dataset.psBundlePanel !== id; });
        items.forEach(function (item) {
          if (item.dataset.tierId !== id) item.checked = false;
        });
        track('pst_bundle_tier_selected', { tier_id: id });
        update();
      }

      function selectedItems() {
        return items.filter(function (item) { return item.checked; }).map(function (item) {
          var selected = { id: item.dataset.variantId, quantity: 1 };
          var properties = matchingProperties(item);
          if (Object.keys(properties).length) selected.properties = properties;
          return selected;
        });
      }

      function update() {
        var selected = items.filter(function (item) { return item.checked; });
        var cents = selected.reduce(function (sum, item) { return sum + (parseInt(item.dataset.price, 10) || 0); }, 0);
        if (total) total.textContent = selected.length ? money(cents) : 'None selected';
        if (summary) {
          summary.innerHTML = '';
          selected.forEach(function (item) {
            var row = document.createElement('li');
            var label = document.createElement('span');
            var remove = document.createElement('button');
            label.textContent = item.dataset.productTitle || 'Selected product';
            remove.type = 'button';
            remove.className = 'ps-link';
            remove.textContent = 'Remove';
            remove.addEventListener('click', function () {
              item.checked = false;
              track('pst_bundle_component_removed', { tier_id: item.dataset.tierId || '' });
              update();
            });
            row.appendChild(label);
            row.appendChild(remove);
            summary.appendChild(row);
          });
        }
        if (button) button.disabled = selected.length === 0;
        if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
      }

      items.forEach(function (item) { on(item, 'change', function () {
        track(item.checked ? 'pst_bundle_component_added' : 'pst_bundle_component_removed', {
          tier_id: item.dataset.tierId || '',
          component_role: item.dataset.productTitle || ''
        });
        if (item.checked) track('pst_bundle_item_added', { product_id: item.dataset.variantId || '', placement: 'bundle_builder', bundle_tier: item.dataset.tierId || '' });
        update();
      }); });
      tierButtons.forEach(function (tierButton) { on(tierButton, 'click', function () { selectTier(tierButton.dataset.psBundleTier); }); });
      update();

      on(button, 'click', function () {
        var selected = selectedItems();
        if (!selected.length) return;
        var activeItem = items.find(function (item) { return item.checked; });
        var activeTierId = activeItem ? itemTier(activeItem) : '';
        function itemTier(item) { return item.dataset.tierId || ''; }
        track('pst_bundle_add_attempted', { tier_id: activeTierId });
        var original = button.textContent;
        button.disabled = true;
        button.textContent = 'Adding…';
        addToCart(selected).then(function (data) {
          button.textContent = 'Added';
          openCartDrawer(sectionFromResponse(data));
          fetchCart().catch(function (error) { announce(error.message); });
          var contract = currentConfiguration();
          track('pst_bundle_attached', {
            design_id: contract.design_id || '',
            colour_id: contract.colour_id || '',
            kit_id: contract.kit_id || '',
            bundle_type: bundle.dataset.psBundleType || 'selected_extras'
          });
          track('pst_bundle_add_succeeded', { design_id: contract.design_id || '', colour_id: contract.colour_id || '', kit_id: contract.kit_id || '', tier_id: activeTierId });
          track('pst_bundle_completed', { design_id: contract.design_id || '', colour_id: contract.colour_id || '', kit_id: contract.kit_id || '', placement: 'bundle_builder', bundle_tier: activeTierId });
          window.setTimeout(function () { button.textContent = original; update(); }, 1600);
        }).catch(function (error) {
          button.textContent = original;
          button.disabled = false;
          if (errorBox) { errorBox.textContent = error.message; errorBox.hidden = false; }
          track('pst_bundle_add_failed', { tier_id: activeTierId, error_code: 'cart_add_failed' });
          announce(error.message);
        });
      });
    });
  }

  function initTabbedCatalogs(root) {
    $$('[data-ps-tabcat]', root).forEach(function (catalog) {
      if (catalog._psInit) return;
      catalog._psInit = true;
      var tabs = $$('[data-ps-tabcat-tab]', catalog);
      var cards = $$('[data-ps-tabcat-item]', catalog);
      var empty = $('[data-ps-tabcat-empty]', catalog);

      function select(category) {
        var visible = 0;
        tabs.forEach(function (tab) {
          var active = tab.dataset.psTabcatTab === category;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
        });
        cards.forEach(function (card) {
          var show = category === 'all' || card.dataset.psTabcatItem === category;
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (empty) empty.hidden = visible > 0;
      }

      tabs.forEach(function (tab) { on(tab, 'click', function () { select(tab.dataset.psTabcatTab); }); });
      select('all');
    });
  }

  function initAddressForms(root) {
    $$('select[name="address[country]"][data-default]', root).forEach(function (select) {
      if (select.dataset.default) select.value = select.dataset.default;
    });
  }

  function initRecommendations(root) {
    $$('[data-ps-recommendations]', root).forEach(function (section) {
      if (section._psRecommendationsInit || $('[data-ps-recommendations-content]', section)) return;
      section._psRecommendationsInit = true;
      var url = section.dataset.url;
      if (!url) return;
      fetch(url).then(function (response) {
        if (!response.ok) throw new Error('Recommendations unavailable.');
        return response.text();
      }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-ps-recommendations]');
        if (!fresh || !fresh.querySelector('[data-ps-recommendations-content]')) return;
        section.innerHTML = fresh.innerHTML;
        initCarousels(section);
        initCart(section);
        initReveal(section);
      }).catch(function () { section.hidden = true; });
    });
  }

  function initHeroVideos(root) {
    $$('.ps-hero', root).forEach(function (hero) {
      if (hero._psVideoInit) return;
      var video = $('video', hero);
      var button = $('[data-ps-video-toggle]', hero);
      var label = button ? $('[data-ps-video-toggle-label]', button) : null;
      if (!video || !button || !label) return;
      hero._psVideoInit = true;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function update(paused) {
        button.setAttribute('aria-pressed', String(paused));
        label.textContent = paused ? button.dataset.playLabel : button.dataset.pauseLabel;
      }

      if (reduceMotion) {
        video.pause();
        button.dataset.psUserPaused = 'true';
        update(true);
      } else update(video.paused);

      on(button, 'click', function () {
        if (video.paused) {
          button.dataset.psUserPaused = 'false';
          video.play().then(function () { update(false); }).catch(function () { update(true); });
        } else {
          button.dataset.psUserPaused = 'true';
          video.pause();
          update(true);
        }
      });

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              video.pause();
              update(true);
            } else if (button.dataset.psUserPaused !== 'true' && !reduceMotion) {
              video.play().then(function () { update(false); }).catch(function () { update(true); });
            }
          });
        }, { threshold: 0.15 });
        observer.observe(hero);
      }
    });
  }

  /* ==========================================================
     SCROLL REVEAL
     ========================================================== */
  function initReveal(root) {
    var els = $$('.ps-reveal', root);
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ==========================================================
     BOOT
     ========================================================== */
  function initAll(root) {
    root = root || document;
    initAttribution();
    if (window.PSTAnalytics && window.PSTAnalytics.campaignUrl) {
      $$('[data-pst-campaign-link]', root).forEach(function (link) {
        link.href = window.PSTAnalytics.campaignUrl(link.href);
      });
    }
    initAnnounce(root);
    initHeader(root);
    initPredictiveSearch(root);
    initBeforeAfter(root);
    initCarousels(root);
    initCountdown(root);
    initHotspots(root);
    initFilters(root);
    initAccordions(root);
    initPopup(root);
    initCart(root);
    initOfferInteractions(root);
    initProductForm(root);
    initConversionTracking(root);
    initMatchingConfiguration(root);
    initBundleBuilders(root);
    initTabbedCatalogs(root);
    initRecommendations(root);
    initAddressForms(root);
    initHeroVideos(root);
    initReveal(root);
  }
  PS.initAll = initAll;

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    fetchCart().catch(function (error) { announce(error.message); });
    on($('[data-ps-scrim]'), 'click', closeAllPanels);
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape') closeAllPanels();
      trapOpenDialog(e);
    });
  });

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
})();
